/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import { baseApiV2 } from "../../constants/Presets";

//
// ─── SERVICE FOR FETCHING PENDING USER NOTIFICATION ─────────────────────────────
//

export function FetchPendingUserNotif(payload) {
  const url = `${baseApiV2}user/adminNotification?`;
  const params = [];
  const customerCode = payload.companyId || "";
  params.push(`companyId=${customerCode}`);
  const userId = payload.userId || "";
  params.push(`userId=${userId}`);
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}

//
// ─── SERVICE FOR FETCHING TRIAL PERIOD NOTIFICATION ─────────────────────────────
//

export function FetchTrialPeriodNotif(payload) {
  return axios.get(`${baseApiV2}alerts/trialPeriod?companyId=${payload}`);
}
